import app from './feathers'
// const authService = app.service('authentication')

const methods = {
    async login() {
        try {
            const auth = await app.authenticate()
            return auth
        } catch (e) {
            return false
        }
    },

    async reAuthFromToken() {
        try {
            const auth = await app.reAuthenticate()
            return auth
        } catch (e) {
            methods.removeToken()
            return e
        }
    },

    async getToken() {
        const auth = await app.authentication.getAccessToken()
        return auth
    },

    async setToken(token) {
        const res = await app.authentication.setAccessToken(token)
        return res
    },

    async removeToken() {
        const res = await app.authentication.removeAccessToken()
        return res
    },

    async logout() {
        return await app.logout()
    },

    async codeLogin(token, type) {
        try {
            const auth = await app.authenticate({
                strategy: 'code',
                apiKey: token,
                type,
            })

            return auth
        } catch (e) {
            return false
        }
    },
}

export default methods
